<template>
    <button
        class="hero-ic ml-2"
        type="button"
        @click="renameProject"
    >
        <v-icon size="10" color="currentColor">mdi-pencil</v-icon>
    </button>
</template>

<script>
export default {
    name: 'RenameProjectBtn',
    props: {
        projectId: {
            type: String,
        },
        color: {
            type: String,
        },
    },
    computed: {},
    components: {},
    data: () => ({}),
    methods: {
        renameProject() {
            this.$store.dispatch('project/callRenameProjectDialog', this.projectId)
        },
    },
    mounted() {},
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
.hero-ic
    width: 22px
    height: 22px
    border-radius: 50%
    background: rgba(255,255,255,.1)
    border: none
    cursor: pointer
    display: flex
    align-items: center
    justify-content: center
    color: rgba(255,255,255,.5)
    font-size: 10px
    position: relative
    z-index: 1
    transition: all 0.2s ease

.hero-ic:hover
    background-color: rgba(255, 255, 255, .24) !important
    color: $ghost-new

.hero-ic:active
    background-color: rgba(255, 255, 255, .3) !important
    transform: translateY(1px)

.hero-ic:focus-visible
    outline: 2px solid rgba(255, 255, 255, .5)
    outline-offset: 1px

.hero-ic ::v-deep .v-icon
    color: inherit !important
    opacity: 1 !important
    margin-top: 1px
</style>
